// Live measurement bills 1 credit per 30 seconds of an open session
// (physiology continuous API, CREDIT_USAGE_RATE = 30). Keep in sync.
export const SECONDS_PER_CREDIT = 30;

// Human-readable measurement time a credit balance buys, rounded down so
// the page never promises more than the balance covers.
export function describeMeasurementTime(credits) {
    const seconds = Math.floor(credits) * SECONDS_PER_CREDIT;
    if (seconds <= 0) return "no measurement time";
    if (seconds < 60) return `about ${seconds} seconds`;

    const totalMinutes = Math.floor(seconds / 60);
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    const plural = (n, unit) => `${n} ${unit}${n === 1 ? "" : "s"}`;

    if (hours === 0) return `about ${plural(minutes, "minute")}`;
    if (minutes === 0) return `about ${plural(hours, "hour")}`;
    return `about ${plural(hours, "hour")} ${plural(minutes, "minute")}`;
}
